import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Box, ClickAwayListener } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
const Search = ({ setSearch, search }) => {
  const [clicked, setClicked] = useState(false);

  const handleClickAway = () => {
    setClicked(false);
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box
        className=" h-[2.8rem] w-full lg:w-[400px] border border-[#dbdfea] rounded-md flex items-center justify-between px-3 py-2 "
        sx={{
          transition: (theme) =>
            theme.palette.mode === "light" ? "all 500ms" : "none",
          color: (theme) =>
            theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
          background: (theme) =>
            theme.palette.mode === "light"
              ? clicked
                ? "#fff"
                : "#f7f7f7"
              : "#0e102d",
        }}
        onClick={() => setClicked(true)}
      >
        <input
          className="border-0 outline-0 w-[95%] bg-transparent md:text-base text-[15px]"
          onChange={(e) => setSearch(e)}
          value={search || ""}
          placeholder="جستجو ..."
        />
        <button
          className="bg-transparent border-0 cursor-pointer"
          type="submit"
        >
          {search ? (
            <HighlightOffIcon
              onClick={() => {
                setSearch({
                  target: {
                    value: "",
                  },
                });
              }}
            />
          ) : (
            <SearchIcon />
          )}
        </button>
      </Box>
    </ClickAwayListener>
  );
};

export default Search;
